import { ADD_CONVERSATION_LIST } from '#app/constants/chat.ts'

import {
	type State,
	type Action,
	type ConversationBackendDataAttributes,
} from '#types/chat/index.ts'

const grabConversationList = (
	conversationList: ConversationBackendDataAttributes,
) => {
	return conversationList.attributes.results.map(conversation => {
		return {
			id: conversation.conversationId,
			title: conversation.title,
			updatedAt: conversation.updatedAt,
		}
	})
}

export function addConversationList(state: State, action: Action): State {
	if (action.type !== ADD_CONVERSATION_LIST) {
		return state
	}

	switch (action.typeOfDispatch) {
		case 'add':
			const conversationListAdd = grabConversationList(action.payload)
			const newConversationMap = new Map()

			state.conversationList.forEach(conversation =>
				newConversationMap.set(conversation.id, conversation),
			)

			conversationListAdd.forEach(conversation => {
				if (!newConversationMap.has(conversation.id)) {
					newConversationMap.set(conversation.id, conversation)
				}
			})

			const updatedConversationListAdd = Array.from(newConversationMap.values())

			return {
				...state,
				currentPagesLoaded: state.currentPagesLoaded + 1,
				isCurrentlyFetchingMoreConversations: false,
				conversationList: updatedConversationListAdd,
			}

		case 'create':
			const conversationListCreate = grabConversationList(action.payload)

			return {
				...state,
				isCurrentlyFetchingMoreConversations:
					state.isCurrentlyFetchingMoreConversations,
				totalConversations: action.meta.pagination.total,
				conversationList: conversationListCreate,
				coinsLeft: action.payload.attributes.totalCoinsLeft,
				tokensLeft: action.payload.attributes.totalTokensLeft,
				intakeStatus: action.payload.attributes.intakeStatus,
			}

		case 'delete':
			const updatedConversationList = state.conversationList.filter(
				conversation => conversation.id !== action.conversationId,
			)

			return {
				...state,
				conversationList: updatedConversationList,
			}

		default:
			return state
	}
}
